import './PopupWrapper.scss';

import { TColor } from 'petdna-lib-uicomponents/hygraph';
import React, { CSSProperties, PropsWithChildren } from 'react';

interface IPopupWrapperProps extends PropsWithChildren {
  borderColor?: TColor
}

const PopupWrapper: React.FC<IPopupWrapperProps> = ({ children, borderColor }) => (
  <div className="modal show popup-wrapper">
    <div className="modal-dialog">
      <div
        className="modal-content"
        style={
            {
              '--top-border-color': borderColor?.hex,
            } as CSSProperties
          }
      >
        {children}
      </div>
    </div>
  </div>
);

export default PopupWrapper;
